export default "__VITE_ASSET__f11ca39f__"